import { lang } from '@/utils/filters'
// console(lang('请输入'))
import { bus } from '@utils/common'

const RULESJson = function() {
  return {
    required: { message: lang('请输入'), required: true, trigger: ['blur', 'change'] },
    requiredTrim: { required: true, pattern: '[^ \x22]+', message: lang('请输入'), trigger: ['blur', 'change'] },
    requiredSelect: { message: lang('请选择'), required: true, trigger: ['blur', 'change'] },
    lengthTwo: { min: 0, max: 2, message: lang('限2个字符内'), trigger: ['blur'] },
    lengthFive: { min: 5, max: 5, message: lang('限5个字符'), trigger: ['blur'] },
    lengthTenThirdteen: { min: 10, max: 12, message: lang('限10-12个字符'), trigger: ['blur', 'change'] },
    fourty: { max: 40, message: lang('限40个字符内'), trigger: ['blur', 'change'] },
    senderName: { min: 1, max: 11, message: lang('姓名不正确'), trigger: ['blur', 'change'] }, // 寄件人姓名
    senderMobilePhone: { min: 0, max: 11, validator: checkPhone, trigger: ['blur', 'change'] }, // 寄件人手机号
    receiverName: { min: 2, max: 11, message: lang('姓名不正确'), trigger: ['blur', 'change'] },
    receiverMobilePhone: { min: 0, max: 11, validator: checkPhone, trigger: ['blur', 'change'] }, // 收件人手机号
    // goods: { message: '请输入物品类型', trigger: ['blur', 'change'] }, // 物品类型名称
    goodsName: { message: lang('请输入物品名称'), trigger: ['blur', 'change'] }, // 物品名称
    packageTotalWeight: { validator: integerWeight, trigger: ['blur', 'change'] }, // 物品重量
    packageNumber: { validator: integerNum, trigger: ['blur', 'change'] }, // 物品件数
    // payment: { message: '请输入支付方式名称', trigger: ['blur', 'change'] }, // 支付方式名称
    declaredValue: { validator: integerNum, trigger: ['blur', 'change'] }, // 物品价值
    checkPassword: { validator: checkPassword, trigger: ['blur', 'change'] }, // 验证密码
    tenNumStrChar: { validator: tenNumStr, trigger: ['blur', 'change'] }, // 验证密码
    checkPhone: { validator: checkPhone, trigger: ['blur', 'change'] },
    phoneAndMobile: { validator: phoneAndMobile, trigger: ['blur', 'change'] },
    checkPhone60: { validator: checkPhone60, trigger: ['blur', 'change'] }, // 手机号60开头
    canNotHasChinase: { validator: canNotHasChinase, trigger: ['blur', 'change'] },
    isNum: { validator: isNum, trigger: ['blur', 'change'] },
    requiredSelectInsured: { message: lang('请选择是否保价'), required: true, trigger: ['blur', 'change'] },
  }
}
export const RULES = RULESJson()
bus.$on('langJsonChange', (data) => {
  const RULESJsonData = RULESJson()
  Object.keys(RULESJsonData).forEach(element => {
    RULES[element] = Object.assign({}, RULESJsonData[element])
  })
})
export const VALIDATION = {
  'num_chinese_en': {
    'value': /^([\u4e00-\u9fa5A-Za-z0-9]{1,12})$/i,
    'label': lang('中文字符/数字/英文，长度为1-12位'),
  },
  'canNotHasChinase': {
    'value': /[\u4E00-\u9FA5]/i,
    'label': lang('不能输入中文'),
  },
  // 'phoneNumber': {
  //   'value': /^1[3|4|5|7|8][0-9]\d{8,8}$/,
  //   'label': '输入的手机号码格式不正确',
  // },
  'phoneNumber': {
    // 'value': /^1\d{10}$/,
    'value': /\d$/, // 国际版去掉限制
    'label': lang('输入的手机号码格式不正确'),
  },
  'phoneAndMobile': {
    'value': /^[0-9\(\)\-\+\s]+$/i,
    'label': lang('数字或连接符- + () 组成'),
  },
  'checkPhone60': {
    'value': /^60.*/,
    'label': lang('请输入60开头10-12位的数字'),
  },
  'address': {
    'value': /.*/i,
    'label': lang('输入的地址格式不正确'),
  },
  'float': {
    'value': /(^[1-9](\d+)?(\.\d{1,2})?$)|(^\d\.\d{1,2}$)/i,
    'label': lang('请输入大于0且保留两位小数点的数字'),
  },
  'integerNum': {
    'value': /^([1-9][0-9]*)$/i,
    'label': lang('请输入大于0的整数'),
  },
  'checkPassword': {
    'value': /^[A-Z][A-Za-z0-9]{5,17}$/,
    'label': lang('请输入大写字母开头的6-18位英文和数字'),
  },
  // 'ten_num_str': {
  //   'value': /^([@,\.#%'\+\*\-:;^_`()&$/A-Za-z0-9]{1,12})$/i,
  //   'label': '仅支持10个以内的字母、数字、部分符号',
  // },
  'ten_num_str': {
    'value': /^([A-Za-z0-9]{1,10})$/i,
    'label': lang('仅支持10个以内的字母、数字'),
  },
  'checkBlack': {
    'value': /\s+/,
    'label': '请输入',
  },
  'isNum': {
    'value': /^[0-9]*$/,
    'label': '只允许输入数字',
  },
}

// @desc 权限名称30个中文字符/数字/英文
export function num_chinese_en(rule, value, callback) {
  if (value && !VALIDATION.num_chinese_en.value.test(value)) {
    callback(new Error(lang(VALIDATION.num_chinese_en.label)))
  } else {
    callback()
  }
}
// 校验手机号不能超过11位，且为数字 TODO
export function checkPhone(rule, value, callback) {
  if (value && !VALIDATION.phoneNumber.value.test(value)) {
    callback(new Error(lang(VALIDATION.phoneNumber.label)))
  } else {
    callback()
  }
}

// 手机号和座机号
export function phoneAndMobile(rule, value, callback) {
  if (value && !VALIDATION.phoneAndMobile.value.test(value)) {
    callback(new Error(lang(VALIDATION.phoneAndMobile.label)))
  } else {
    if (VALIDATION.checkBlack.value.test(value)) {
      callback(new Error(lang('请勿输入空格')))
    } else {
      callback()
    }
  }
}
// 校验手机号60开头
export function checkPhone60(rule, value, callback) {
  if (value && !VALIDATION.checkPhone60.value.test(value)) {
    callback(new Error(VALIDATION.checkPhone60.label))
  } else {
    callback()
  }
}
// 校验输入的地址格式是否正确
export function checkAddressFormat(rule, value, callback) {
  if (value.length < 1 || value.length > 200) {
    callback(new Error(lang('详细地址只能在1-200字符之间')))
  } else {
    if (value && !VALIDATION.address.value.test(value)) {
      callback(new Error(lang(VALIDATION.address.label)))
    } else {
      callback()
    }
  }
}
//  小数
export function integerWeight(rule, value, callback) {
  if (!value && !VALIDATION.float.value.test(value)) {
    callback(new Error(lang(VALIDATION.float.label)))
  } else {
    callback()
  }
}
//  纯数字
export function integerNum(rule, value, callback) {
  if (value && !VALIDATION.integerNum.value.test(value)) {
    callback(new Error(lang(VALIDATION.integerNum.label)))
  } else {
    callback()
  }
}
export function isNum(rule, value, callback) {
  if (value && !VALIDATION.isNum.value.test(value)) {
    callback(new Error(lang(VALIDATION.isNum.label)))
  } else {
    callback()
  }
}

// 验证密码
export function checkPassword(rule, value, callback) {
  if (value && !(VALIDATION.checkPassword.value.test(value) && (/\d/).test(value))) {
    callback(new Error(lang(VALIDATION.checkPassword.label)))
  } else {
    callback()
  }
}

// 物品名称
export function checkGoodsName(rule, value, callback) {
  if (value.length > 100) {
    callback(new Error(lang('物品名称长度不能大于100个字符')))
  } else {
    callback()
  }
}

export function tenNumStr(rule, value, callback) {
  if (value && !VALIDATION.ten_num_str.value.test(value)) {
    callback(new Error(lang(VALIDATION.ten_num_str.label)))
  } else {
    callback()
  }
}

// 是否为{}空对象
export function isNullObj(rule, value, callback) {
  if (JSON.stringify(value) === '{}') {
    callback(new Error(lang('请选择')))
  } else {
    callback()
  }
}

// 是否为空格
export function isNull(rule, value, callback) {
  if (VALIDATION.checkBlack.value.test(value)) {
    callback(new Error(lang('请勿输入空格')))
  } else {
    callback()
  }
}

// 不能有中文
export function canNotHasChinase(rule, value, callback) {
  if (VALIDATION.canNotHasChinase.value.test(value)) {
    callback(new Error(lang('不能输入中文')))
  } else {
    callback()
  }
}

export function isName(rule, value, callback) {
  if (value.length > 50) {
    callback(new Error(lang('姓名长度不能大于50个字符')))
  } else {
    callback()
  }
}
